export enum HttpStatusCodes {
  NoContent = 204,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409
}
